import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import {
    DataGrid,
    Column,
    Scrolling,
    Selection,
} from "devextreme-react/data-grid";
import DynamicFromLookup from "../../../../../dynamicFormBuilder/DynamicFromLookup";
import { IDWarehouseLookupLayout } from "../../../../../common/lookups/Layouts/IdLayouts";
import axios from "axios";
import notify from "devextreme/ui/notify";
import { MESSAGES } from "../../../../../common/Messages";
import { alert } from "devextreme/ui/dialog";

const ChangeWarehousePopup = (props) => {
    const {
        visible,
        onClose,
        currentWarehouseId,
        currentWarehouseName,
        transactionNumber,
        transactionDetailId,
        itemCode,
        lotCode,
        getDetailGridItems,
        accessToken: accessTokenProp,
        apiUrl = "om/SalesOrderHeaderOperations/ChangeWarehouse",
        onSuccess,
    } = props;
    const accessToken = accessTokenProp ?? props.oidc?.user?.access_token;

    const [formFields, setFormFields] = useState({ NewWarehouseId: null, NewWarehouseName: null });
    const [recordsNotProcessed, setRecordsNotProcessed] = useState([]);
    const changeWarehouseCurrentRef = useRef(null);
    const changeWarehouseNewRef = useRef(null);

    const handleClose = () => {
        setFormFields({ NewWarehouseId: null, NewWarehouseName: null });
        setRecordsNotProcessed([]);
        onClose();
    };

    useEffect(() => {
        if (visible) setRecordsNotProcessed([]);
    }, [visible]);

    const handleOk = async () => {
        if (!currentWarehouseId) {
            alert(MESSAGES.CURRENT_WAREHOUSE_MUST_BE_ENTERED, MESSAGES.ERROR);
            return;
        }
        if (!formFields.NewWarehouseId) {
            alert(MESSAGES.NEW_WAREHOUSE_MUST_BE_ENTERED, MESSAGES.ERROR);
            return;
        }
        if (formFields.NewWarehouseId === currentWarehouseId) {
            alert(MESSAGES.CURRENT_AND_NEW_WAREHOUSES_MUST_DIFFER, MESSAGES.ERROR);
            return;
        }
        props.setLoadPanelVisible(true);
        try {
            const url = `${window._env_.REACT_APP_APIS}/${apiUrl}`;
            let requestBody;
            if (typeof getDetailGridItems === "function") {
                const detailItems = await Promise.resolve(getDetailGridItems());
                const rows = Array.isArray(detailItems) ? detailItems : [];
                requestBody = {
                    RWarehouse: formFields.NewWarehouseId,
                    warehousecode: formFields.NewWarehouseName ?? "",
                    currentWarehouseId: currentWarehouseId,
                    details: rows.map((row) => ({
                        RTransactiondetail: row.Rowid ?? row.ROWID ?? row.RowID,
                        ItemCode: row.ItemCode ?? row.itemCode ?? "",
                        LotCode: row.LotCode ?? row.lotCode ?? "",
                    })),
                };
            } else {
                requestBody = {
                    RTransactiondetail: props.transactionDetailId,
                    RWarehouse: formFields.NewWarehouseId,
                    warehousecode: formFields.NewWarehouseName,
                    ItemCode: props.itemCode,
                    LotCode: props.lotCode,
                };
            }
            const res = await axios.post(
                url,
                requestBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const data = res.data;
            const notProcessedList = data?.notProcessed ?? data?.NotProcessed;
            const hasNotProcessed = Array.isArray(notProcessedList) && notProcessedList.length > 0;
            const success = data?.success ?? data?.Success;
            const isSuccess = data !== false && success !== false;
            const warehouseName = formFields.NewWarehouseName ?? "";

            if (hasNotProcessed) {
                const list = notProcessedList.map((entry) => ({
                    item: entry.itemCode ?? "",
                    lot: entry.lotCode ?? "",
                    reason: entry.reason ?? "",
                }));
                setRecordsNotProcessed(list);
            } else if (isSuccess) {
                onSuccess();
                handleClose();
                return;
            } else if (typeof getDetailGridItems === "function") {
                const detailItems = await Promise.resolve(getDetailGridItems());
                const rows = Array.isArray(detailItems) ? detailItems : [];
                const list = rows.map((row) => ({
                    item: row.itemCode ?? "",
                    lot: row.lotCode ?? "",
                    reason: ("Item \"{itemCode}\" Not Valid For Warehouse \"{warehouseName}\".")
                        .replace("{itemCode}", row.itemCode ?? "")
                        .replace("{warehouseName}", warehouseName),
                }));
                setRecordsNotProcessed(list);
            }
        } catch (err) {
            notify({ message: err?.response?.data?.message || err?.message || "Change warehouse failed", width: 300 }, "error", 5000);
        } finally {
            props.setLoadPanelVisible(false);
        }
    };

    const handleCancel = () => {
        handleClose();
    };

    const closeRecordsNotProcessed = () => {
        setRecordsNotProcessed([]);
    };



    return (
        <>
            <Popup
                visible={visible}
                onHiding={handleClose}
                width={520}
                height={200}
                title={`Change Warehouse`}
                showCloseButton={true}
            >
                <div style={{ display: "flex", gap: 16, marginBottom: 16, flexWrap: "wrap" }}>
                    <div style={{ flex: 1, minWidth: 200 }}>
                        <DynamicFromLookup
                            fieldRef={(el) => { changeWarehouseCurrentRef.current = el; }}
                            name="CurrentWarehouseId"
                            required={false}
                            field={{ name: "CurrentWarehouseId", tableName: "OMTRANSACTIONHEADER", label: "Current Warehouse", type: "lookup",lookupDisplayMode: "grid", layout: IDWarehouseLookupLayout, readOnly: true }}
                            formFields={{ CurrentWarehouseId: currentWarehouseId }}
                            layout={IDWarehouseLookupLayout}
                            onValueChanged={() => { }}
                            editMode={true}
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 200 }}>
                        <DynamicFromLookup
                            fieldRef={(el) => { changeWarehouseNewRef.current = el; }}
                            name="NewWarehouseId"
                            required={false}
                            field={{ name: "NewWarehouseId", tableName: "OMTRANSACTIONHEADER", label: "New Warehouse", type: "lookup",lookupDisplayMode: "grid", layout: IDWarehouseLookupLayout }}
                            formFields={formFields}
                            layout={IDWarehouseLookupLayout}
                            onValueChanged={(e) => {
                                setFormFields((prev) => ({
                                    ...prev,
                                    NewWarehouseId: e.value,
                                    NewWarehouseName: e.text ?? prev.NewWarehouseName,
                                }));
                            }}
                            handleSelectionChange={(name, selectedRow) => {
                                if (selectedRow) {
                                    setFormFields((prev) => ({
                                        ...prev,
                                        NewWarehouseId: selectedRow.id ?? selectedRow[IDWarehouseLookupLayout.valueExpr],
                                        NewWarehouseName: selectedRow.name ?? selectedRow[IDWarehouseLookupLayout.displayExpr],
                                    }));
                                }
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 35 }}>
                    <Button
                        text="OK"
                        type="default"
                        icon="check"
                        stylingMode="contained"
                        onClick={handleOk}
                    />
                    <Button
                        text="Cancel"
                        icon="close"
                        stylingMode="outlined"
                        onClick={handleCancel}
                    />
                </div>
            </Popup>
            {
                recordsNotProcessed.length > 0 && (
                    <Popup
                        visible={recordsNotProcessed.length > 0 }
                        onHiding={closeRecordsNotProcessed}
                        width={600}
                        height={400}
                        title="Records Not Processed"
                        showCloseButton={true}
                    >
                        <div className="records-not-processed-grid" style={{ marginBottom: 16 }}>
                            <DataGrid
                                dataSource={recordsNotProcessed}
                                showBorders={true}
                                columnAutoWidth={true}
                                height={280}
                                noDataText="No records"
                                headerFilter={{ visible: false }}
                            >
                                <Scrolling mode="standard" />
                                <Selection mode="single" />
                                <Column dataField="item" caption="Item" allowHeaderFiltering={false} />
                                <Column dataField="lot" caption="Lot" allowHeaderFiltering={false} />
                                <Column dataField="reason" caption="Reason" allowHeaderFiltering={false} width="auto" />
                            </DataGrid>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                text="OK"
                                type="default"
                                icon="check"
                                stylingMode="contained"
                                onClick={closeRecordsNotProcessed}
                            />
                        </div>
                    </Popup>
                )
            }
        </>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ChangeWarehousePopup);